import Repository from './repositoryType';

const emptyRepository: Repository = {
  IsPublic: false,
  LastUpdateTimestamp: '',
  LatestCommitTitle: '',
  LatestCommitUrl: '',
  Name: '',
  OrganizationID: '',
  Summary: '',
  UUID: '',
  Url: '',
  UserID: '',
  VectorDBURL: '',
  PRBotEnabled: false,
  IssueBotEnabled: false,
  ContinuousUpdatesEnabled: false,
  IsMergedRepository: false,
};

export default emptyRepository;
